// The brand dot (snippets/brand-wordmark.liquid, brand-dot-init.liquid):
// the "." in STUDIE.H is a colour swatch, and its colour (--dot) runs through
// the site's small accents. It follows the Forside colour picked on a product
// page, and a click on the dot in the header steps it to the next filament
// colour. The choice is remembered in this browser.
(function () {
  var KEY = 'studieh-dot';
  var palette = window.studiehDots || [];
  var root = document.documentElement;

  function set(entry) {
    root.style.setProperty('--dot', entry.hex);
    root.style.setProperty('--dot-ink', entry.dark ? '#fffdf8' : '#241f1a');
    try {
      localStorage.setItem(KEY, JSON.stringify({ hex: entry.hex, dark: entry.dark }));
    } catch (e) {}
  }

  function current() {
    var hex = getComputedStyle(root).getPropertyValue('--dot').trim().toLowerCase();
    for (var i = 0; i < palette.length; i++) {
      if (palette[i].hex.toLowerCase() === hex) return i;
    }
    return -1;
  }

  // The dot sits inside the logo's home link: a click on it changes the
  // colour instead of following the link. A little hop shows it took.
  document.addEventListener('click', function (evt) {
    var dot = evt.target.closest && evt.target.closest('[data-brand-dot]');
    if (!dot || !palette.length) return;
    evt.preventDefault();
    set(palette[(current() + 1) % palette.length]);
    document.querySelectorAll('[data-brand-dot]').forEach(function (d) {
      d.classList.remove('is-hopping');
      void d.offsetWidth;
      d.classList.add('is-hopping');
    });
  });

  // Product page: the Forside colour is the cover's main colour.
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.matches || !input.matches('input[type="radio"][data-option-name="Forside"]')) return;
    for (var i = 0; i < palette.length; i++) {
      if (palette[i].hex.toLowerCase() === (input.dataset.hex || '').toLowerCase()) {
        set(palette[i]);
        return;
      }
    }
  });
})();
